import VillagePage from '@/components/VillagePage';

const SaintMartinDeRe = () => {
  return (
    <VillagePage
      villageName="Saint-Martin-de-Ré"
      description="Chef-lieu de l'Île de Ré, Saint-Martin est un village fortifié classé UNESCO avec son port pittoresque et ses ruelles commerçantes."
      attractions={[
        "Fortifications Vauban (UNESCO)",
        "Port de plaisance historique",
        "Citadelle et musée Ernest Cognacq",
        "Ruelles commerçantes",
        "Marché couvert",
        "Église Saint-Martin"
      ]}
      bikeRoutes={[
        "Tour des fortifications (4 km)",
        "Vers La Flotte (6 km)",
        "Vers Ars-en-Ré (10 km)",
        "Circuit des marais salants (12 km)"
      ]}
      practicalInfo={{
        beaches: ["Plage de la Cible", "Plage des Grenettes"],
        restaurants: ["Restaurants du port", "Bistrots", "Glaciers"],
        markets: ["Marché quotidien en été", "Marché couvert"]
      }}
    />
  );
};

export default SaintMartinDeRe;